import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {DialogContentBase, DialogModule, DialogRef, KENDO_DIALOGS} from '@progress/kendo-angular-dialog';
import {EditorModule} from '@progress/kendo-angular-editor';
import {InputsModule} from '@progress/kendo-angular-inputs';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {LabelModule} from '@progress/kendo-angular-label';
import {DropDownsModule} from '@progress/kendo-angular-dropdowns';
import {LayoutModule} from '@progress/kendo-angular-layout';
import {AutoFocusDirective} from '../../directives/auto-focus.directive';
import {Discipline, EvaluationRatingScaleType, EvaluationType} from '../../models/models.lib';
import {CasiCloseOptions, FormModes} from '../../common/constants.lib';
import {LoggerService} from '../../shared/logger.service';
import {DisciplineService} from '../../discipline/discipline.service';
import {duplicateEvaluationRatingScaleValidator, duplicateEvaluationValidator} from '../../common/utils.lib';
import {IntegerOnlyDirective} from '../../directives/integer-only';

@Component({
  selector: 'casi-evaluation-rating-scale-add.component',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    DialogModule,
    EditorModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    LayoutModule,
    AutoFocusDirective,
    IntegerOnlyDirective,
    KENDO_DIALOGS
  ],
  templateUrl: './evaluation-rating-scale-add.component.html',
  styleUrl: './evaluation-rating-scale-add.component.scss'
})
export class EvaluationRatingScaleAddComponent   extends DialogContentBase implements OnInit {

  private _evaluationRatingScale: EvaluationRatingScaleType | undefined;

  @Input() title: string = 'Title Not Set';

  @Input({ required: true }) existingData: EvaluationRatingScaleType[] = [];

  @Input({ required: true }) set evaluationRatingScale(val: EvaluationRatingScaleType) {
    this._evaluationRatingScale = val;
    this.editForm.patchValue(this._evaluationRatingScale);
  }
  get evaluationRatingScale(): EvaluationRatingScaleType | undefined {
    return this._evaluationRatingScale;
  };

  private _mode: FormModes = FormModes.NOTSET;
  @Input({ required: true }) set mode(val: FormModes) {
    this._mode = val;
  }
  get mode(): FormModes {
    return this._mode;
  };

  editForm: FormGroup;

  constructor(
    public override dialog: DialogRef,
    private fb: FormBuilder,
    private logger: LoggerService,
    private dataService: DisciplineService
  ) {
    super(dialog);
    this.editForm = this.fb.group(
      {
        id: [null, []],
        // rating_scale_value: [null, [Validators.required, Validators.min(0), Validators.pattern(/^[0-9]+$/)]],
        rating_scale_value: [null, [Validators.required]],
        rating_scale_description: [null, [Validators.required]],
        rating_scale_name: [null, [Validators.required]],
        evaluation_id: [null, [Validators.required]]
      }
    );
  }

  //#region Form

  get f() {
    return this.editForm.controls;
  }
  get rating_scale_value() {
    return this.editForm.get('rating_scale_value');
  }
  get rating_scale_description() {
    return this.editForm.get('rating_scale_description');
  }

  get rating_scale_name() {
    return this.editForm.get('rating_scale_name');
  }
  //#endregion

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
    this.editForm.setValidators(
      duplicateEvaluationRatingScaleValidator(this.existingData, this.mode)
    );
  }

  public onCancelAction(): void {
    this.logger.debug(`onCancelAction...`);
    this.dialog.close({ text: CasiCloseOptions.Cancelled });
  }

  public onSaveAction(): void {
    this.logger.debug(`onSaveAction...`, this.editForm.value);
    if (this.editForm.status !== 'INVALID')
      this.dialog.close({ text: CasiCloseOptions.Saved });
  }


}

